import { render, staticRenderFns } from "./AddEditQuestionWrapper.vue?vue&type=template&id=30457f71"
import script from "./AddEditQuestionWrapper.vue?vue&type=script&lang=js"
export * from "./AddEditQuestionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports